import { Link } from 'react-router-dom';
import { ArrowRight, Calendar } from 'lucide-react';

const blogs = [
  {
    title: 'Our Vision for Cutting-Edge Solutions',
    excerpt: 'We lead the charge in innovation, pushing boundaries to redefine possibilities. Seamlessly integrating technology into everyday life, enhancing experiences through intuitive, user-centric design.',
    date: 'March 2024',
    category: 'Innovation',
  },
  {
    title: 'Nurturing Talent in a Dynamic Environment',
    excerpt: 'In our dynamic environment, we prioritize nurturing talent through various means. We encourage a culture of continuous learning, where employees have access to resources and opportunities for skill development.',
    date: 'February 2024',
    category: 'Culture',
  },
  {
    title: 'Fostering Collaboration and Inclusivity',
    excerpt: 'In our organization, fostering collaboration and inclusivity is paramount. We believe that diverse perspectives and experiences are fundamental to driving innovation and creativity.',
    date: 'January 2024',
    category: 'Team',
  },
];

const BlogPage = () => {
  return (
    <main>
      {/* Hero */}
      <section className="relative min-h-[50vh] flex items-center overflow-hidden">
        <div className="absolute inset-0 bg-surface" />
        <div className="absolute inset-0 hero-gradient" />
        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 pt-32 pb-16 w-full">
          <p className="text-xs font-mono uppercase tracking-[0.3em] text-amber mb-4">Insights & Updates</p>
          <h1 className="font-heading text-4xl md:text-5xl font-bold text-white tracking-tight" data-testid="blog-page-title">
            Blog
          </h1>
          <p className="text-slate-300 mt-4 max-w-xl">
            Stay updated with our latest insights, industry trends, and company news.
          </p>
        </div>
      </section>

      {/* Blog Grid */}
      <section className="py-24 lg:py-32">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {blogs.map((blog) => (
              <article
                key={blog.title}
                className="bg-surface border border-white/10 rounded-sm overflow-hidden card-hover group"
                data-testid={`blog-${blog.title.toLowerCase().replace(/\s+/g, '-')}`}
              >
                <div className="p-8">
                  <div className="flex items-center gap-3 mb-4">
                    <span className="text-xs font-mono uppercase tracking-widest text-amber">{blog.category}</span>
                    <span className="text-slate-600">|</span>
                    <span className="text-xs text-slate-500 flex items-center gap-1">
                      <Calendar className="w-3 h-3" /> {blog.date}
                    </span>
                  </div>
                  <h3 className="font-heading text-lg font-bold text-white mb-3 group-hover:text-amber transition-colors">{blog.title}</h3>
                  <p className="text-sm text-slate-400 leading-relaxed mb-4">{blog.excerpt}</p>
                  <span className="text-amber text-sm font-medium inline-flex items-center gap-1 group-hover:gap-2 transition-all cursor-pointer">
                    Read more <ArrowRight className="w-3.5 h-3.5" />
                  </span>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
};

export default BlogPage;
